import type { DataTableFeatures } from 'design-system';

import type { CatalogItem } from '@/entities/catalog-item';
import { isRecentlyLaunched } from '@/entities/catalog-item';

import type { FilterFn, Row } from '@tanstack/react-table';

export const arrEqualsSome: FilterFn<DataTableFeatures, CatalogItem> = (
  row: Row<DataTableFeatures, CatalogItem>,
  columnId: string,
  filterValue: string[]
) => {
  if (!filterValue.length) return true;
  const value: string | undefined = row.getValue(columnId);
  if (typeof value !== 'string') return false;
  return filterValue.some(
    selectedFilterValue => value.toLocaleLowerCase() === selectedFilterValue.toLocaleLowerCase()
  );
};
export const filterByStatus: FilterFn<DataTableFeatures, CatalogItem> = (
  row: Row<DataTableFeatures, CatalogItem>,
  columnId: string,
  filterValue: boolean
) => {
  if (filterValue) {
    return true;
  }
  const value = row.getValue(columnId);
  return value !== 'Archive';
};

export const filterByNewData: FilterFn<DataTableFeatures, CatalogItem> = (
  row: Row<DataTableFeatures, CatalogItem>,
  columnId: string,
  filterValue: boolean
) => {
  if (!filterValue) return true;
  return isRecentlyLaunched(row.getValue<string | undefined>(columnId), new Date());
};
